/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, {Component} from 'react';
import IconBoxes from '../../components/iconBoxes';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Panel from '../../components/panel.js';

import MonthlyRecovery from '../../charts/monthlyRecovery';
import AmmountPorfolio from '../../charts/amountPorfolio'
import IncomeDiscount from '../../charts/incomeDiscount';
import MonthlyRecoveryAcummulated from '../../charts/monthlyRecoveryAccummulated';
import AnnualAccounts from '../../charts/annualAccounts';
import {Redirect} from 'react-router';
import {ROL} from '../../utils/constants';
import DebtRecovery from "../../tables/debtRcovery";

class PlaceDirection extends Component {

  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData, date: new Date()}
  }

  callback = (dataFromChild) => {
    this.setState({vp: dataFromChild});
  }

  callbackForSelectors = (dataFromChild) => {
    this.setState({date: dataFromChild});
  }

  render() {

    let urlPlace = '';
    if(this.props.match.params.vp === 'Culiacán'){
      urlPlace = 'https://app.powerbi.com/view?r=eyJrIjoiYzk4YjMyNWEtYTlhZi00MTg0LThlMGYtNGRhZWFmYmM5ZjAzIiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'
    } else if (this.props.match.params.vp === 'Vallarta'){
      urlPlace = 'https://app.powerbi.com/view?r=eyJrIjoiZWUwYjI2Y2ItNzJjNS00YTM5LWFlMWEtODc1YjcxM2NkNTViIiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'
    } else if (this.props.match.params.vp === 'Tijuana'){
      urlPlace = 'https://app.powerbi.com/view?r=eyJrIjoiMjZjZmFlZWQtMGYzNS00YTE3LWI4YWEtYTJmZmVjMjY3NmM3IiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'
    } else if (this.props.match.params.vp === 'Tuxpan'){
      urlPlace = 'https://app.powerbi.com/view?r=eyJrIjoiNjZkM2U5MzAtODljZC00NDMyLThlMjgtNDAyNTQzNTRmM2NkIiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'
    }

    var result;

      result = <div>
        <SidebarMenuRouters profile="/direction-home/" place={this.props.match.params.vp} callback={this.callback}/>
        <Header userName={this.state.userData.name} title={"Análisis de desempeño"}/>
        {/*<div className="grid-data-dash">
          <IconBoxes bu={this.props.match.params.vp} callbackFromParent={this.callbackForSelectors}/>
          <div className="row">
            <div className="col-md-6">
              <Panel
                title="Recuperación mensual de adeudos (mdp)"
                righticon={false}>
                <MonthlyRecovery key={'1' + this.state.date} bu={this.props.match.params.vp} date={this.state.date}/>
              </Panel>
            </div>

            <div className="col-md-6">
              <Panel
                title="Ingreso acumulado actual vs año anterior (mdp)"
                righticon={false}>
                <MonthlyRecoveryAcummulated key={'2' + this.state.date} bu={this.props.match.params.vp}
                                            date={this.state.date}/>
              </Panel>
            </div>

            <div className="col-md-6">
              <Panel
                title="Rezago total de la cartera (mdp)"
                righticon={false}>
                <AmmountPorfolio key={'3' + this.state.date} bu={this.props.match.params.vp} date={this.state.date}/>
              </Panel>
            </div>

            <div className="col-sm-6">
              <Panel title="Ingresos vs descuentos (mdp)" righticon={false}>
                <IncomeDiscount key={'4' + this.state.date} bu={this.props.match.params.vp} date={this.state.date}/>
              </Panel>
            </div>

            <div className="col-md-6">
              <Panel
                title="Cuentas pagadas mensualmente"
                righticon={false}>
                <AnnualAccounts key={'1' + this.state.date} bu={this.props.match.params.vp} date={this.state.date}/>
              </Panel>
            </div>

            <div className="col-md-12">
              <Panel
                title="Avances en la recuperación de adeudos"
                righticon={false}>
                <DebtRecovery bu={this.props.match.params.vp} date={this.state.date}/>
              </Panel>
            </div>

          </div>
        </div>*/}

        <div className='d-flex justify-content-start'>
          <iframe width="1880" height="2703"
                  src={urlPlace} frameBorder="0" allowFullScreen="true"/>
        </div>

      </div>;

    return (
      <div>
        {result}
      </div>
    );
  }
}

export default PlaceDirection;



// WEBPACK FOOTER //
// ./src/scene/direction/placeDirection.js